export enum LanguageChannels {
  /**
   * Renderer -> main, synchronous. Answers with the language the app should start in: the
   * one the user last chose, or the OS locale mapped onto a supported language on first
   * run. Synchronous because i18next is initialised before the first render, and an async
   * answer would mean painting one frame in the wrong language.
   */
  INITIAL_LANGUAGE_REQUESTED = 'INITIAL_LANGUAGE_REQUESTED',

  /**
   * Renderer -> main. The user picked a language in Settings. Main persists it and rebuilds
   * the application menu, whose labels it owns.
   */
  LANGUAGE_CHANGED = 'LANGUAGE_CHANGED',
}
